import React from 'react';
import dateFormat from 'dateformat';
import * as Date from '../dates/dateHelpers';
import { markupHelpers } from '../../helpers';
import * as Buttons from '../ui/buttons';
import { getAbbrMonthYear } from './../../../../../../helpers/common/date-util';

export const CertificateItem = props => {
	const {
		name,
		authority,
		license_number,
		start_date,
		end_date,
		url,
		buttonHandlers,
		guestMode,
	} = props;
	const convertedName = markupHelpers.escapeHtmlHelper(name),
		convertedAuthority = markupHelpers.escapeHtmlHelper(authority);

	let start =  start_date ? getAbbrMonthYear( start_date ) : '';
	let end = end_date ? Date.formatEndDate( end_date ) : '';

	return (
		<div className="item-certificates">
			{/*show when not in guestMode*/}
			{!guestMode && (
				<div className="item-display-mode">
					<Buttons.EditButton {...buttonHandlers} />
				</div>
			)}
			{/*/////////*/}
			<div className="row">
				<div className="col-4 col-lg-3 new-profile-label">Name</div>
				<div className="col-8 col-lg-9 new-profile-info item-header">
					<span
						className="width-reducer"
						dangerouslySetInnerHTML={{ __html: convertedName }}
					/>
				</div>
			</div>
			{!authority ? null : (
				<div className="row">
					<div className="col-4 col-lg-3 new-profile-label">Authority</div>
					<div className="col-8 col-lg-9 new-profile-info">
						<span
							className="width-reducer"
							dangerouslySetInnerHTML={{ __html: convertedAuthority }}
						/>
					</div>
				</div>
			)}
			{!license_number ? null : (
				<div className="row">
					<div className="col-4 col-lg-3 new-profile-label">License Number</div>
					<div className="col-8 col-lg-9 new-profile-info">
						{license_number}
					</div>
				</div>
			)}

			{!start_date || start_date === null ? null : (
				<div className="row">
					<div className="col-4 col-lg-3 new-profile-label">Dates</div>
					<div className="col-8 col-lg-9 new-profile-info">
						{ start } -{' '}
						{ end }
					</div>
				</div>
			)}
			{!url ? null : (
				<div className="row">
					<div className="col-4 col-lg-3 new-profile-label">Url</div>
					<div className="col-8 col-lg-9 new-profile-info">
						{url.includes('http') ? (
							<a href={url} target="_blank">
								{url}
							</a>
						) : (
							<a href={`http://${url}`} target="_blank">
								{url}
							</a>
						)}
					</div>
				</div>
			)}
		</div>
	);
};



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/CertificateItem.js